import Request from "utils/requests/api";
import initializeConfig from "utils/requests/api.config";

export const BASE_URL_GATES = async () => {
  const { gates } = await initializeConfig();
  return `${gates}`;
};

export interface IRequestReport {
  locations: number[];
  _minEventTime: string;
  _maxEventTime: string;
  locationTimeZone: string;
  structureId: number;
  plate?: string;
  trailerPlate?: string;
  document?: string;
}

export interface IRequestMovementReport {
  locations: number[];
  _minEventTime: string;
  _maxEventTime: string;
  locationTimeZone: string;
  structureId: number;
  plate?: string;
  trailerPlate?: string;
  dtDocument?: string;
}

export interface IRequestReportTable {
  structureId: number;
  locations: number[];
  _minEventTime: string;
  _maxEventTime: string;
  _size: number;
  _page: number;
  locationTimeZone: string;
  plate?: string;
  trailerPlate?: string;
  document?: string;
}

export interface IRequestMovementReportTable {
  structureId: number;
  locations: number[];
  _minEventTime: string;
  _maxEventTime: string;
  _size: number;
  _page: number;
  locationTimeZone: string;
  plate?: string;
  trailerPlate?: string;
  dtDocument?: string;
}

export const getReport = async ({ structureId, locations, _minEventTime, _maxEventTime, locationTimeZone, trailerPlate, plate, document }: IRequestReport) => {
  const baseUrlGates = await BASE_URL_GATES();
  return (await Request).get(`${baseUrlGates}reports/csv-report/`, {
    structureId,
    locations,
    _minEventTime,
    _maxEventTime,
    locationTimeZone,
    plate,
    trailerPlate,
    document,
  });
};

export const getReportFetchToTable = async ({
  structureId,
  locations,
  _minEventTime,
  _maxEventTime,
  _size,
  _page,
  locationTimeZone,
  trailerPlate,
  plate,
  document,
}: IRequestReportTable) => {
  const baseUrlGates = await BASE_URL_GATES();
  return (await Request).get(`${baseUrlGates}reports:paginated`, {
    structureId,
    locations,
    _minEventTime,
    _maxEventTime,
    _size,
    _page,
    locationTimeZone,
    plate,
    trailerPlate,
    document,
  });
};

export const getMovementReportFetchToTable = async ({
  structureId,
  locations,
  _minEventTime,
  _maxEventTime,
  _size,
  _page,
  locationTimeZone,
  trailerPlate,
  plate,
  dtDocument,
}: IRequestMovementReportTable) => {
  const baseUrlGates = await BASE_URL_GATES();
  return (await Request).get(`${baseUrlGates}reports/vehicle-movements:paginated`, {
    structureId,
    locations,
    _minEventTime,
    _maxEventTime,
    _size,
    _page,
    locationTimeZone,
    plate,
    trailerPlate,
    dtDocument,
  });
};

export const getMovementReport = async ({ structureId, locations, _minEventTime, _maxEventTime, locationTimeZone, trailerPlate, plate, dtDocument }: IRequestMovementReport) => {
  const baseUrlGates = await BASE_URL_GATES();
  return (await Request).get(`${baseUrlGates}reports/vehicle-movements/`, {
    structureId,
    locations,
    _minEventTime,
    _maxEventTime,
    locationTimeZone,
    plate,
    trailerPlate,
    dtDocument,
  });
};
